import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import { SidebarProvider } from './contexts/SidebarContext';
import { CommandPaletteProvider } from './contexts/CommandPaletteContext';
import { DomainProvider } from './contexts/DomainContext';
import './styles/global.css';
ReactDOM.createRoot(document.getElementById('root')).render(_jsx(React.StrictMode, { children: _jsx(BrowserRouter, { children: _jsx(ThemeProvider, { children: _jsx(AuthProvider, { children: _jsx(ToastProvider, { children: _jsx(SidebarProvider, { children: _jsx(CommandPaletteProvider, { children: _jsx(DomainProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }) }));
